<template>
  <ContentWrapperControl class="mt-4">
    <div class="grid grid-cols-2 gap-4">
      <ServicesCardControl
        :icon="require('@/assets/icons/papsi_pnb.png')"
        :title="lang('lbl_0000298')"
        :description="lang('lbl_0000500')"
        href="/bao/pnb"
      />

      <ServicesCardControl
        class="mt-4"
        :icon="require('@/assets/icons/papsi_rcbc.svg')"
        :title="lang('lbl_0000499')"
        :description="lang('lbl_0000501')"
        href="/bao/rcbc"
      />
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import ServicesCardControl from "@/components/controls/ServicesCardControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  emits: ["checkauth", "shownavbar", "nofooter"],
  components: {
    ContentWrapperControl,
    ServicesCardControl,
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000502"),
      show: true,
      back: true,
    });
    this.$emit("nofooter", false);
  },
};
</script>
